


































































































































import { Component, Vue, Watch, Ref } from 'vue-property-decorator';
import DropdownCompare from '@/components/poultry/DropdownCompare.vue';
import Dropdown from '@/components/poultry/Dropdown.vue';
import DropdownFilter from '@/components/poultry/DropdownFilter.vue';
import DropdownFilterSearchBar from '@/components/poultry/DropdownFilterSearchBar.vue';
import { dropdownStores } from '@/store/poultry/dropdowns';
import { Region } from '@/models/poultry/country.model';
import { clientStores } from '@/store/poultry/client/index';
import { ClientResponse } from '@/models/poultry/client.model';
import { farmStores } from '@/store/poultry/farm';
import { auditorStores } from '@/store/poultry/auditor/index';
import { FarmResponse } from '@/models/poultry/farm.model';
import { AuditorResponse } from '@/models/poultry/auditor.model';
import VueMonthlyPicker from 'vue-monthly-picker';
import { analysisStores } from '@/store/poultry/analysis/index';
import ClientNameFilter from '@/views/poultry/Reports/ReportTableFilter/ClientNameFilter.vue';
import { reportStores } from '@/store/poultry/report/index';
import moment from 'moment'; // TODO: Need to use moment as the Month Picker use moment lib
import DropdownFilterAlt from '@/components/poultry/DropdownFilterAlt.vue';
import { DropdownOption } from '@/models/poultry/dropdown.model';
import { reportTypeStores } from '@/store/poultry/reportType';
import { ReportTypeIds } from '../../../../constants';

@Component({
  components: {
    DropdownCompare,
    DropdownFilter,
    DropdownFilterAlt,
    DropdownFilterSearchBar,
    ClientNameFilter,
    Dropdown,
    VueMonthlyPicker,
  },
})
export default class VisualAnalysisPageHeader extends Vue {
  defaultFormat = 'MM/YYYY';
  monthList = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'July',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  clientStore = clientStores.list;
  clientDetailStore = clientStores.details;
  farmStore = farmStores.list;
  farmDetailStore = farmStores.details;
  auditorStore = auditorStores.list;
  auditorDetailStore = auditorStores.details;
  countryStore = dropdownStores.country;
  analysisStore = analysisStores.visual.list;
  reportStore = reportStores.list;
  reportTypeDetailStore = reportTypeStores.detail;
  isBetweenFarms = false;
  isSystemTypeSelected = true;
  isHouseTypeSelected = true;
  defaultFilterType = 'state';
  defaultAnalysisType = 'between_clients';
  clientNameData: Object[] = [];
  // Init type for ref
  @Ref() resetSelectedData!: HTMLFormElement;
  @Ref() activeSelectedDropdown!: any;

  visual: any = {
    houseType: 2,
    systemType: 'all',
    clientIds: [],
    categoryType: null,
    filteredData: [],
    fromMonth: null,
    toMonth: null,
  };

  // This one would be a fixed value
  broilerSystem = [
    { text: 'All', value: 'all' },
    { text: 'Ventilation System', value: 'ventilation' },
    { text: 'Drinking System', value: 'drinking' },
    { text: 'Feeding System', value: 'feeding' },
    { text: 'House', value: 'house' },
    { text: 'House - Pest Control', value: 'pest_control' },
  ];

  layerBreederSystem = [
    { text: 'All', value: 'all' },
    { text: 'Ventilation System', value: 'ventilation' },
    { text: 'Drinking System', value: 'drinking' },
    { text: 'Feeding System', value: 'feeding' },
    { text: 'House', value: 'house' },
    { text: 'House - Pest Control', value: 'pest_control' },
    { text: 'Egg Gathering System', value: 'egg_gathering' },
    { text: 'Manure Disposal System', value: 'manure_disposal' },
    { text: 'Cages or Nests', value: 'cages_nests' },
  ];

  // This one would be a fixed value
  categoryType = [
    { text: 'State', value: 'state' },
    { text: 'Farm', value: 'farm' },
    { text: 'Auditor', value: 'auditor' },
  ];

  // Init data in all store by fetchAll
  async created() {
    const species = this.$router.currentRoute.fullPath.split('/')[1];

    this.clientStore.setSpecies(species);
    await this.clientStore.fetchClients();
    await this.countryStore.fetchCountries();
    await this.countryStore.fetchStatesByCountryCode();
    this.clientNameData = this.clientsName;
  }

  get minMonth() {
    if (this.visual.fromMonth) {
      const oneMonthAfter = moment(this.visual.fromMonth).add(1, 'months');
      return oneMonthAfter;
    }
    return moment(new Date()).add(1, 'months');
  }

  get maxMonth() {
    if (this.visual.fromMonth) {
      const oneYear = moment(this.visual.fromMonth).add(11, 'months');
      return oneYear;
    }
    return moment(new Date()).add(11, 'months');
  }

  @Watch('visual.fromMonth')
  clearMaxMonth() {
    if (this.visual.fromMonth) {
      this.visual.toMonth = null;
    }
  }

  get isCategoryTypeSelected() {
    return !this.visual.categoryType;
  }

  get disableDropdown() {
    return !this.visual.clientIds.length;
  }

  // To get list of clients in dropdown filter
  get clients(): ClientResponse[] {
    return this.clientStore.clientsDropdown;
  }

  get clientsName() {
    return Object.values(this.clients).map((client) => {
      return {
        text: client.name,
        value: String(client.id),
      };
    });
  }

  // To get list of states in dropdown filter
  get regions(): Region[] {
    return this.countryStore.regions;
  }

  get regionsName() {
    return Object.values(this.regions).map(({ name, id }: any) => {
      return {
        text: name,
        value: id,
      };
    });
  }

  get isCleaningAndDisinfectionAuditType(): boolean {
    return this.reportTypeDetailStore.reportTypeId.toString() === ReportTypeIds.cnd;
  }

  async searchByClientName(inputClientName: any) {
    // Filter the Client Objects here.
    if (!inputClientName.trim()) {
      this.clientNameData = this.clientsName;
    } else {
      await this.clientStore.searchByKeywords({
        keywords: inputClientName,
      });

      this.clientNameData = this.clientStore.clients.map((client) => {
        return {
          text: client.name,
          value: String(client.id),
        };
      });
    }
  }

  // To get list of farms in dropdown filter
  get farms(): FarmResponse[] {
    return this.farmDetailStore.farmsDropdown;
  }

  get farmsName() {
    return Object.values(this.farms).map((farm) => {
      return {
        text: farm.name,
        value: String(farm.id),
      };
    });
  }

  // To get list of auditors in dropdown filter
  get auditors(): AuditorResponse[] {
    return this.auditorDetailStore.auditorsDropdown;
  }

  get auditorsName() {
    return this.auditors.map((auditor) => {
      return {
        text: auditor.userProfile.name,
        value: String(auditor.id),
      };
    });
  }

  resetVisualAnalysisCreated() {
    if (this.analysisStore.isCreated) {
      return this.analysisStore.setVisualCreated(false);
    }
  }

  // This watcher is to reset value in category and selection
  @Watch('analysisStore.clientName')
  clearCategoryAndSelections() {
    this.visual.categoryType = null;
    this.resetSelectedData['selectedData'] = [];
  }

  // First Dropdown compare filter: Values are between_clients and between_farms
  comparisonTypeChanged(comparisonType: DropdownOption) {
    this.resetVisualAnalysisCreated;
    if (comparisonType.value === 'between_farms') {
      this.isBetweenFarms = true;
      this.defaultAnalysisType = comparisonType.value;
      this.visual.clientIds = [];
    } else {
      this.isBetweenFarms = false;
      this.defaultAnalysisType = comparisonType.value;
      this.visual.clientIds = [];
    }
  }

  houseTypeChanged(houseType: DropdownOption) {
    this.resetVisualAnalysisCreated;
    if (houseType.value === '') {
      this.isHouseTypeSelected = false;
    } else {
      this.isHouseTypeSelected = true;
      this.visual.houseType = houseType.value;
      this.visual.systemType = 'all';
      this.analysisStore.setHouseType(houseType);
    }
  }

  systemTypeChanged(systemType: DropdownOption) {
    this.resetVisualAnalysisCreated;
    if (systemType.value === '') {
      this.isSystemTypeSelected = false;
    } else {
      this.isSystemTypeSelected = true;
      this.visual.systemType = systemType.value;
      this.analysisStore.setSystemType(systemType);
    }
  }

  // First Dropdown filter: List of Clients
  handleClientChanged(params: DropdownOption) {
    this.resetVisualAnalysisCreated;
    this.activeSelectedDropdown['isActive'] = true;
    this.visual.clientIds = [];
    this.analysisStore.setClientName(params);
    this.visual.clientIds.push(params.value);
  }

  // Second Dropdown filter: Values are Farm, Auditor and State
  handleCategoryTypeChanged(params: DropdownOption) {
    this.resetSelectedData['selectedData'] = [];
    this.clientDetailStore.setClientId(
      Number(this.visual.clientIds.toString())
    );
    this.visual.categoryType = params.value;
    if (params.value === 'farm') {
      this.farmDetailStore.fetchFarmsDropdown({
        clientId: this.visual.clientIds[0],
        cities: [],
        state: '',
      });
    }
    if (params.value === 'auditor') {
      this.auditorDetailStore.fetchAuditorsDropdown(this.visual.clientIds[0]);
    }
  }

  // Third Dropdown filter: Watch if there are changes (selected) in State, Farm and Auditor Dropdown
  // then call the respective API for data listing in dropdown filter
  @Watch('defaultFilterType')
  onChangeCategoryType() {
    if (this.visual.categoryType === 'state') {
      return this.regionsName;
    }
    if (this.visual.categoryType === 'farm') {
      return this.farmsName;
    }
    if (this.visual.categoryType === 'auditor') {
      return this.auditorsName;
    }
  }

  filterClientName(filteredData: []) {
    this.visual.clientIds = [...filteredData];
  }

  onCloseClientNameDropdown(selectedData: []) {
    this.visual.clientIds = [...selectedData];
  }

  filterCategoryName(filteredData: []) {
    this.visual.filteredData = [...filteredData];
  }

  onCloseCategoryTypeDropdown(selectedData: []) {
    this.visual.filteredData = [...selectedData];
  }

  // When generate button is clicked
  handleGenerateReport() {
    this.analysisStore.setAnalysisType(this.defaultAnalysisType);
    this.analysisStore.setStartDate(
      moment(this.visual.fromMonth!).format('YYYY-MM')
    );
    this.analysisStore.setEndDate(
      moment(this.visual.toMonth!).format('YYYY-MM')
    );
    this.analysisStore.setClientIds(this.visual.clientIds);
    this.analysisStore.setReportTypeId(this.reportTypeDetailStore.reportTypeId);
    // TODO: Refactor
    if (this.visual.categoryType === 'state') {
      this.analysisStore.setStates(this.visual.filteredData);
    }
    if (this.visual.categoryType === 'farm') {
      this.analysisStore.setFarms(this.visual.filteredData);
    }
    if (this.visual.categoryType === 'auditor') {
      this.analysisStore.setAuditors(this.visual.filteredData);
    }
    //
    this.analysisStore.setCategoryType(this.visual.categoryType);
    this.analysisStore.fetchAll();
  }

  get visuals() {
    return this.analysisStore.visual;
  }

  @Watch('visual')
  get dropdownIsValid(): boolean {
    const excludedKeys: string[] = [];

    // Push key that doesn't have in between clients to excludedkeys array
    if (this.defaultAnalysisType === 'between_clients') {
      excludedKeys.push('categoryType');
      excludedKeys.push('filteredData');
    }

    // Filter keys that have same value as in the result object, exclude it and put it in new array
    const keys = Object.keys(this.visual).filter(
      (key) => excludedKeys.includes(key) === false
    );

    // Check each keys whether got values or empty
    const values = keys.map((key) => {
      // if no values in array of clientIds or in filteredData return false
      if (
        (key === 'clientIds' && !this.visual[key].length) ||
        (key === 'filteredData' && !this.visual[key].length)
      ) {
        return false;
      }
      return this.visual[key];
    });
    return values.every(Boolean);
  }
}
